import {routes as app} from '../app'
import Home from '../app/domains/Home'
import CertificateValidator from '../app/domains/CertificateValidator'

// Rotas default da aplicação
const root = [
  {path: '/', redirect: '/registration/all'},
  {path: '/home', component: Home, name: 'home'},
  {path: '/validate', component: CertificateValidator, name: 'validate', meta: {auth: false}}
]

export default [...root, ...app]
